module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-bar"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b0eaa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 453
// module chunks = 1